import { memo } from 'react'

import { useNotifications } from '~/shared/lib/notifications'
import { Portal } from '~/shared/ui/Portal'

import { AnimatedNotification } from './components/AnimatedNotification'

import styles from './NotificationList.module.scss'

/**
 * Стек уведомлений сверху экрана. Высоту хедера Telegram берёт из CSS-переменной,
 * которую публикует PlatformProvider — импортировать платформу отсюда нельзя,
 * она сама рисует свой UI из ui-kit и получился бы цикл. Подключается один раз в app/providers — дальше уведомления
 * показываются императивно (notifications.show/success/error/warning/info из
 * shared/lib/notifications) из любого места, в т.ч. вне React. Архитектура — как в
 * NotificationList эталонного ui-kit (стор + подписка + анимированный список), визуал — свой,
 * по токенам продукта.
 *
 * Новые уведомления рисуются сверху стека (реверс массива — старые уходят вниз), появление —
 * сверху вниз, уход — вверх (см. AnimatedNotification).
 */
export const NotificationList = memo(function NotificationList() {
  const { items } = useNotifications()

  if (items.length === 0) return null

  return (
    <Portal>
      <div className={styles.stack}>
        {[...items].reverse().map((item) => (
          <AnimatedNotification key={item.id} item={item} />
        ))}
      </div>
    </Portal>
  )
})
